import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SVGIcon, SVGIconComponent } from "@progress/kendo-angular-icons";
import { questionCircleIcon } from "@progress/kendo-svg-icons";

@Component({
  selector: 'app-tour-button',
  standalone: true,
  imports: [
    SVGIconComponent
  ],
  templateUrl: './tour-button.component.html',
  styleUrl: './tour-button.component.css'
})

export class TourButtonComponent {
  @Input() icon: SVGIcon = questionCircleIcon;
  @Output() tourStart = new EventEmitter<void>();

  onStartTour(): void {
    this.tourStart.emit();
  }
}
